import { Component } from 'react';
import { Field } from 'redux-form';

import { TextArea, CheckBox } from 'common/components/forms';

class GiftMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isGiftMessage: (props.clubSignup && props.clubSignup.giftMessage) || false
    };
  }

  handleGiftChange = (e) => {
    this.setState({ isGiftMessage: e.target.checked });
  };

  render() {
    const { isGiftMessage } = this.state;
    return (
      <>
        <Field
          name="isGiftMessage"
          type="checkbox"
          component={CheckBox}
          onChange={this.handleGiftChange}
          value="1"
          label="Add gift message"
        />
        {isGiftMessage && (
          <Field
            name="giftMessage"
            component={TextArea}
            label="Gift message"
            rows={5}
          />
        )}
      </>
    );
  }
}

export default GiftMessage;
